export default {
  translation: {
    common: {
      accept: '수락',
      alreadyUser: '이미 사용자입니까?',
      and: '및',
      backToLogin: '로그인 페이지로 돌아가기',
      continueWith: '{{provider}}로 계속',
      coreNotFound: '코어 설정을 가져오지 못했습니다',
      createAccount: '계정 생성',
      createYourAccount: '계정을 생성하세요',
      emailOrUsername: '이메일 또는 사용자 이름',
      invalidUsernameOrPassword: '잘못된 사용자 이름 또는 비밀번호',
      localRegistrationDisabled: '로컬 사용자 등록이 관리자에 의해 비활성화됨',
      login: '로그인',
      logInToBoards: '로그인',
      newToBoards: '4ga Boards 처음이신가요?',
      noInternetConnection: '인터넷 연결 없음',
      pageNotFound_title: '페이지를 찾을 수 없습니다',
      password: '비밀번호',
      policyNotAccepted: '이용약관 및 개인정보처리방침에 동의해 주세요',
      privacyPolicy: '개인정보처리방침',
      register: '회원가입',
      registerWithGoogle: 'Google로 가입',
      registrationDisabled: '사용자 등록이 관리자에 의해 비활성화됨',
      serverConnectionFailed: '서버 연결 실패',
      ssoRegistrationDisabled: 'SSO 등록이 관리자에 의해 비활성화됨',
      termsOfService: '이용약관',
      togglePasswordVisibility: '비밀번호 표시/숨김',
      unknownError: '알 수 없는 오류, 나중에 다시 시도하세요',
    },

    action: {
      logIn: '로그인',
    },
  },
};
